export const formatCurrency = (price: number | bigint): string | number | bigint => {
	if (!price) {
		return price;
	}
	const formatter = new Intl.NumberFormat("uk-UA", {
		style: "currency",
		currency: "UAH",
		currencyDisplay: "narrowSymbol"
	});

	return formatter.format(price);
};
